/* eslint-disable import/no-anonymous-default-export */
import http from "../../helpers/http";
import qs from 'qs'

export default {
    getCoa: (token, search, limit) => ({
        type: 'GET_COA',
        payload: http(token).get(`/coa/get?search=${search}&limit=${limit}`)
    }),
    getAllCoa: (token, search) => ({
        type: 'GET_ALLCOA',
        payload: http(token).get(`/coa/all?search=${search === undefined ? '' : search}`)
    }),
    addCoa: (token, data) => ({
        type: 'ADD_COA',
        payload: http(token).post(`/coa/add`, qs.stringify(data))
    }),
    updateCoa: (token, id, data) => ({
        type: 'UPDATE_COA',
        payload: http(token).patch(`/coa/update/${id}`, qs.stringify(data)),
    }),
    deleteCoa: (token, id, data) => ({
        type: 'DELETE_COA',
        payload: http(token).patch(`/coa/delete/${id}`, qs.stringify(data)),
    }),
    getDetailCoa: (token, id) => ({
        type: 'GET_DETAIL_COA',
        payload: http(token).get(`/coa/detail/${id}`)
    }),
    nextPage: (token, link) => ({
        type: 'NEXT_DATA_COA',
        payload: http(token).get(`${link}`)
    }),
    uploadMaster: (token, data) => ({
        type: 'UPLOAD_MASTERCOA',
        payload: http(token).post(`/coa/master`, data)
    }),
    resetError: () => ({
        type: 'RESET_COA'
    })
}